var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Link = function (props) { return (_jsxs("svg", __assign({ width: "18", height: "13", viewBox: "0 0 18 13", fill: "none", stroke: "#DB2B19", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("path", { d: "M6.78947 7.94736H9.10526C11.0237 7.94736 12.5789 6.39215 12.5789 4.47368V4.47368C12.5789 2.55522 11.0237 1 9.10526 1H4.47368C2.55522 1 1 2.55522 1 4.47368V5.05263C1 6.65135 2.29602 7.94736 3.89474 7.94736V7.94736", strokeWidth: "1.5" }), _jsx("path", { d: "M10.842 5.05264H8.52623C6.60777 5.05264 5.05255 6.60786 5.05255 8.52633V8.52633C5.05255 10.4448 6.60777 12 8.52623 12H13.1578C15.0763 12 16.6315 10.4448 16.6315 8.52633V7.94738C16.6315 6.34866 15.3355 5.05264 13.7368 5.05264V5.05264", strokeWidth: "1.5" })] }))); };
